module.exports = __webpack_public_path__ + "img/texas_brown_ba_detail_rsh(1).b7403d1f.jpg";